module.exports = __webpack_public_path__ + "img/10551395_S.dee44032.png";